<template>
  <div v-bind:style="{ fontSize: $store.getters.fontSize + 'px' }">
    <div>
      <table style="width:100%">
        <tr>
          <td :class="mobil? 'width20px':'width40px'">
            <v-icon @click="show = !show" x-large>
              {{show ? 'expand_less': 'expand_more'}}
            </v-icon>
          </td>
          <td>
            <slot name="header"></slot>
          </td>
        </tr>
      </table>
    </div>
    <transition name="fade">
      <div v-show="show">
        <slot name="body"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
			show: true,
    };
  },
  computed:{
    mobil(){
      return ['xs','sm'].includes(this.$vuetify.breakpoint.name)
    },
  }
};
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>

